import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { safeStorage } from './safeStorage';

import translationKO from '@/locales/ko.json';
import translationEN from '@/locales/en.json';
import translationES from '@/locales/es.json';
import translationZH_CN from '@/locales/zh-CN.json';
import translationZH_TW from '@/locales/zh-TW.json';
import translationHI from '@/locales/hi.json';
import translationVI from '@/locales/vi.json';
import translationTL from '@/locales/tl.json';
import translationFR from '@/locales/fr.json';

const resources = {
  ko: {
    translation: translationKO,
  },
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
  'zh-CN': {
    translation: translationZH_CN,
  },
  'zh-TW': {
    translation: translationZH_TW,
  },
  hi: {
    translation: translationHI,
  },
  vi: {
    translation: translationVI,
  },
  tl: {
    translation: translationTL,
  },
  fr: {
    translation: translationFR,
  },
};

// Detect browser language
const getBrowserLanguage = (): string => {
  const browserLang = navigator.language || (navigator as any).userLanguage;
  
  // Extract primary language code (e.g., 'en-US' -> 'en')
  const langCode = browserLang.split('-')[0];
  
  // Check if we support this language
  const supportedLanguages = ['ko', 'en', 'es', 'zh', 'hi', 'vi', 'tl', 'fr'];
  
  // Handle Chinese variants
  if (browserLang === 'zh-CN') return 'zh-CN';
  if (browserLang === 'zh-TW' || browserLang === 'zh-HK') return 'zh-TW';
  
  // Return the language if supported, otherwise fallback
  return supportedLanguages.includes(langCode) ? langCode : 'en';
};

// Default to English, allow users to change via Settings
// Use safeStorage to prevent crashes in private browsing mode
const savedLanguage = safeStorage.getItem('language', 'en') || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on('languageChanged', (lng) => {
  safeStorage.setItem('language', lng);
});

export default i18n;
